/* CRO lot 6 — Linkify Pro, swatches de collection : image haute résolution au survol.
   Au survol d'un swatch, l'app remplace la photo de la vignette par l'URL "_large" (480 px) du coloris,
   affichée sur ~580 px (x2 sur Retina) => floue. Ce script réécrit ces URLs au moment où l'app les pose :
   suffixe "_large" retiré + paramètre width= (600 px x densité d'écran, plafonné à 2000), adapté aux photos
   portrait et aux écrans Retina. UNIQUEMENT pour les images situées dans une vignette de grille et UNIQUEMENT
   pour les URLs Shopify CDN "_large". Aucun autre script du thème ne produit d'URL "_large" (le thème utilise ?width=).
   Retirer ce fichier = retour à l'état d'origine. */
(function () {
  var desc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
  if (!desc || !desc.set || !desc.get) return;
  var RE = /^(?:https?:)?\/\/cdn\.shopify\.com\/s\/files\/[^?#]*_large\.(?:jpe?g|png|webp|gif)(?:\?.*)?$/i;
  var W = Math.min(2000, Math.round(600 * Math.max(1, window.devicePixelRatio || 1)));
  Object.defineProperty(HTMLImageElement.prototype, 'src', {
    configurable: true,
    enumerable: desc.enumerable,
    get: desc.get,
    set: function (v) {
      try {
        if (typeof v === 'string' && RE.test(v) && this.closest && this.closest('.grid-product, .grid-item, .grid__item')) {
          v = v.replace(/_large\.([a-z]+)/i, '.$1');
          v += (v.indexOf('?') === -1 ? '?' : '&') + 'width=' + W;
        }
      } catch (e) {}
      return desc.set.call(this, v);
    }
  });
})();
